<div class="header-wrapper">
  {{params.displayName}}
  <button *ngIf="isResetAvailable()" title="{{  'plan.dist.reset.btn' | translate}}"
        [ngClass]="{'disabled': isDisabled()}" [disabled]="isDisabled()"
        class="btn btn-secondary icon-undo" data-testid="reset-week-icon"
        [ngbPopover]="confirmReset" triggers="click" container="body" popoverClass="reset-popup"></button>
</div>

<ng-template #confirmReset>
  <div class="message-text">
    <p>{{"plan.dist.reset.msg.body" | translate }} </p>
  </div>
  <div class="button-response">
    <breeze-button [isSecondary]="true" [showTooltip] = "false" buttonText="{{'btn.cancel.label' | translate }}"></breeze-button>
    <breeze-button [isPrimary]="true" [showTooltip] = "false" buttonText="{{'btn.confirm.label' | translate }}" (clicked)="resetColumn()"></breeze-button>
  </div>
</ng-template>

